module.exports = __webpack_public_path__ + "img/axe_3_processus.458e5bf9.svg";